var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ibox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-content table-responsive" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.conversaciones.length > 0
            ? _c("div", { staticClass: "ibox-content" }, [
                _c("div", { attrs: { id: "morris-bar-chart" } }),
              ])
            : _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    padding: "50px 0px",
                    "text-align": "center",
                  },
                },
                [_c("h4", [_vm._v("No se encontraron resultados")])]
              ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12" }, [
          _c("div", { staticClass: "ibox float-e-margins" }, [
            _vm._m(2),
            _vm._v(" "),
            _vm.por_hora.length > 0
              ? _c("div", { staticClass: "ibox-content" }, [
                  _c("div", { attrs: { id: "morris-one-line-chart" } }),
                ])
              : _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      padding: "50px 0px",
                      "text-align": "center",
                    },
                  },
                  [_c("h4", [_vm._v("No se encontraron resultados")])]
                ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("Graficos")]),
      _vm._v(" "),
      _c("div", { staticClass: "ibox-tools" }, [
        _c("a", { staticClass: "collapse-link" }, [
          _c("i", { staticClass: "fa fa-chevron-up" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("Interacciones por hora")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("Cantidad de interacciones por hora")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", { staticStyle: { "font-size": "11px" } }, [
              _vm._v("Porcentaje Interacciones Resueltas"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content", attrs: { id: "percent" } }, [
            _c("div", [
              _c("div", {
                staticStyle: { width: "300px" },
                attrs: { id: "resueltas" },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", { staticStyle: { "font-size": "11px" } }, [
              _vm._v(
                "\r\n                            Porcentaje Interacciones Sin resolver\r\n                        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", [
              _c("div", {
                staticStyle: { width: "300px" },
                attrs: { id: "sresolver" },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", { staticStyle: { "font-size": "11px" } }, [
              _vm._v("Porcentaje Interacciones Pendientes/Contestadas"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", [
              _c("div", {
                staticStyle: { width: "300px" },
                attrs: { id: "pendientes" },
              }),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12" }, [
        _c(
          "h4",
          {
            staticStyle: {
              "margin-left": "auto",
              width: "173px",
              "margin-right": "auto",
            },
          },
          [_vm._v("Interacciones sin resolver")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", { staticStyle: { "font-size": "11px" } }, [
              _vm._v("Porcentaje Interacciones Expiradas"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", [
              _c("div", {
                staticStyle: { width: "300px" },
                attrs: { id: "expiradas" },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", { staticStyle: { "font-size": "11px" } }, [
              _vm._v("Porcentaje Cerrado Insatisfactorio"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", [
              _c("div", {
                staticStyle: { width: "300px" },
                attrs: { id: "insatisfactorias" },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-2" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("h4", { staticStyle: { "padding-left": "15px" } }, [
        _vm._v("Interacciones Finalizadas"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c("div", { staticClass: "ibox float-e-margins" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", [_vm._v("Interacciones finalizadas")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ibox-content" }, [
            _c("div", [_c("div", { attrs: { id: "pie" } })]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }